import { useI18n } from 'builder/hooks/useI18n'
import { useUser } from 'builder/hooks/useUser'

import { TRANSLATION } from '../../../constants'
import { Service } from '../../../../types'

type ResumeDistributionInfo = {
  badge?: string
  header: string
  subHeader: string
  actionText: string
  recruiters?: string
}

type ResumeDistributionProps = {
  text: ResumeDistributionInfo
  status: 'initial' | 'progress' | 'completed'
  recruitersCount?: number
}

export const useResumeDistributionConfig = (
  service: Service,
  categoryId: string,
): ResumeDistributionProps => {
  const user = useUser()
  const { i18n } = useI18n()
  const hasCandidate = !!user?.scopes.resumeDistributionCandidate

  const getStatus = () => {
    if (hasCandidate) return 'progress'
    if (service.calculatedProgress?.percentageProgress || 0 >= 100) return 'completed'
    return 'initial'
  }

  const getText = (): ResumeDistributionInfo => {
    const status = getStatus()
    if (status === 'completed') {
      return i18n.t(`${TRANSLATION}.completed`) as unknown as ResumeDistributionInfo
    }

    return {
      badge: i18n.t(`${TRANSLATION}.resume_distribution.${categoryId}.${status}.badge`),
      header: i18n.t(`${TRANSLATION}.resume_distribution.${categoryId}.${status}.header`),
      subHeader: i18n.t(`${TRANSLATION}.resume_distribution.${categoryId}.${status}.subHeader`),
      recruiters: i18n.t(`${TRANSLATION}.resume_distribution.${categoryId}.${status}.recruiters`),
      actionText: i18n.t(`${TRANSLATION}.resume_distribution.${categoryId}.${status}.actionText`, {
        count: 50,
      }),
    }
  }

  return {
    text: getText(),
    status: getStatus(),
    recruitersCount: service.progress,
  }
}
